import { Flex, type FlexProps } from 'antd';
import {
  type ComponentProps,
  type FC,
  type PropsWithChildren,
  type ReactNode,
  isValidElement,
} from 'react';
import { Box } from '../Box';
import { Text } from '../Text';
import { PDF_BORDER, SECTION_TITLE_BACKGROUND_COLOR } from './constants';

type Props = {
  title?: ReactNode | string | number;
  titleWrapperStyle?: FlexProps['style'];
  titleContentStyle?: FlexProps['style'];
  wrapperStyle?: FlexProps['style'];
  innerStyle?: FlexProps['style'];
  contentWrapperStyle?: FlexProps['style'];
  titleTextProps?: Omit<ComponentProps<typeof Text>, 'text'>;
};

export const ReportSectionItem: FC<PropsWithChildren<Props>> = ({
  title,
  titleWrapperStyle,
  titleContentStyle,
  wrapperStyle,
  innerStyle,
  titleTextProps,
  children,
}) => {
  return (
    <Flex
      gap={2}
      style={{
        border: PDF_BORDER.THIN,
        boxSizing: 'border-box',
        height: '100%',
        ...wrapperStyle,
      }}
    >
      {title && (
        <Flex
          style={{
            justifyContent: 'center',
            alignItems: 'flex-start',
            width: 140,
            padding: '2px 8px',
            borderRight: PDF_BORDER.THIN,
            backgroundColor: SECTION_TITLE_BACKGROUND_COLOR,
            boxSizing: 'border-box',
            ...titleWrapperStyle,
          }}
        >
          {isValidElement(title) ? (
            <>{title}</>
          ) : (
            <Flex
              align="center"
              style={{
                padding: '2px 8px',
                boxSizing: 'border-box',
                ...titleContentStyle,
              }}
            >
              <Text
                variant="footnote"
                {...titleTextProps}
                style={{ textAlign: 'center', ...titleTextProps?.style }}
                text={title as string | number}
              />
            </Flex>
          )}
        </Flex>
      )}
      <Box width="100%" borderLeft="1px solid" {...innerStyle}>
        {children}
      </Box>
    </Flex>
  );
};
